<template>
  <div>
    <v-divider class="mt-1" :color="theme.orders_divider_color" />
    <v-layout row>
      <v-flex xs12>
        <v-checkbox
          v-model="useVouchers"
          :color="theme.btn_color_secondary"
          @change="changeUseVouchers"
        >
          <template slot="label">
            <span :style="nameStyle">{{ $t('use_my_vouchers') }}</span>
          </template>
        </v-checkbox>
      </v-flex>
    </v-layout>
    <div
      v-if="useVouchers"
      style="margin-top: -18px"
    >
      <v-layout
        v-for="v in filteredDiscounts"
        :key="v.voucher_id"
        row
        align-center
        class="option"
      >
        <v-flex xs12>
          <v-radio-group
            v-model="selected"
            @change="changeVoucher"
          >
            <v-radio
              :disabled="!checkConditions(v)"
              :value="v.voucher_id"
              :color="theme.btn_color_secondary"
            >
              <template slot="label">
                <span :style="nameStyle">{{ v.name }}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </div>
    <!--    <div-->
    <!--      v-if="useVouchers"-->
    <!--      style="margin-top: -18px"-->
    <!--    >-->
    <!--      <v-layout row>-->
    <!--        <v-flex-->
    <!--          xs9-->
    <!--          text-xs-right-->
    <!--        >-->
    <!--          <h4 :style="nameStyle">Discount:</h4>-->
    <!--        </v-flex>-->
    <!--        <v-flex-->
    <!--          xs3-->
    <!--          text-xs-right-->
    <!--        >-->
    <!--          <h4 :style="nameStyle">-{{ $n(paymentDiscount, 'currency') }}</h4>-->
    <!--        </v-flex>-->
    <!--      </v-layout>-->
    <!--      <v-layout row>-->
    <!--        <v-flex-->
    <!--          xs9-->
    <!--          text-xs-right-->
    <!--        >-->
    <!--          <h4 :style="nameStyle">Payment After Discount:</h4>-->
    <!--        </v-flex>-->
    <!--        <v-flex-->
    <!--          xs3-->
    <!--          text-xs-right-->
    <!--        >-->
    <!--          <h4 :style="nameStyle">{{ $n(paymentAmountAfterDiscount, 'currency') }}</h4>-->
    <!--        </v-flex>-->
    <!--      </v-layout>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      useVouchers: true,
      selected: null,
      filteredDiscounts: null
    }
  },
  computed: {
    ...mapGetters('order', [
      'activeOrder'
    ]),
    ...mapGetters('voucher', [
      'discounts',
    ]),
    ...mapGetters('cart', [
      'vouchers', 'discountInfo', 'discountInfoIsFilled', 'cart', 'cartAmount'
    ]),
    ...mapGetters('config', [
      'theme', 'posType', 'mode'
    ]),
    ...mapGetters('menu', [
      'menuItem', 'menuItemPrice', 'menuItemQty',
      'menuItemReady', 'menuItemCourseItems', 'menuItemOptions',
      'menuItemToppings', 'menuItemRequired'
    ]),
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    dark () {
      return parseInt(this.theme.main_menu_theme) === 1
    },
    paymentAmount () {
      if (!this.activeOrder) return 0
      return parseFloat(this.activeOrder.payments_topay)
    },
    paymentDiscount () {
      if (this.paymentAmount === 0) return 0
      if (this.discountInfoIsFilled) {
        if (this.discountInfo.discount_type === 'Price') {
          return this.discountInfo.discount_amount
        } else {
          const rate = parseFloat(this.discountInfo.discount_amount) / 100
          return this.paymentAmount * rate
        }
      }
      return 0
    },
    paymentAmountAfterDiscount () {
      return this.paymentAmount - this.paymentDiscount
    }
  },
  methods: {
    checkConditions (v) {
      return v && this.checkDineMode(v) && this.checkMinimum(v) && this.checkUnlimitedUse(v)
    },
    checkUnlimitedUse (v) {
      if (v && !v.gems_member_voucher) return false
      return v.gems_member_voucher.UnlimitedUse || (!v.gems_member_voucher.UnlimitedUse && !v.used)
    },
    checkDineMode (v) {
      let currentMode
      if (this.mode.isDinein) currentMode = '1'
      if (this.mode.isTakeaway) currentMode = '2'
      if (this.mode.isDelivery) currentMode = '3'

      if (v && !v.gems_member_voucher) return false
      const dineModeJson = JSON.parse(v.gems_member_voucher.DineMode)
      return dineModeJson ? dineModeJson.includes(currentMode) : true
    },
    checkMinimum (v) {
      if (v && !v.gems_member_voucher) return false
      let minAmt = parseFloat(v.gems_member_voucher.MinBillAmount)
      return minAmt > 0 ? parseFloat(this.cartAmount) >= minAmt : true
    },
    // checkStack (v) {
    //   if (this.applied(v)) { //applied
    //     if (!v.gems_member_voucher.Stackable) { //cannot stack
    //       return this.vouchers.length === 0
    //     } else { // can stack
    //       // check cart voucher allow stack
    //       const appliedVoucher = this.discounts.find(v => v.voucher_id === this.vouchers[0].voucher_id )
    //       return !!appliedVoucher.gems_member_voucher.Stackable
    //     }
    //   } else { // not applied
    //     if (v.gems_member_voucher.Stackable) { //cannot stack
    //       return this.vouchers.length === 0
    //     } else { //can stack
    //       // check cart voucher allow stack
    //       if (this.vouchers.length > 0) { // other voucher applied
    //         const appliedVoucher = this.discounts.find(v => v.voucher_id === this.vouchers[0].voucher_id )
    //         return !!appliedVoucher.gems_member_voucher.Stackable
    //       } else { // no voucher applied
    //         return true
    //       }
    //     }
    //   }
    // },
    // applied (voucher) {
    //   return this.vouchers.find(v => v.voucher_id === voucher.voucher_id) ? true : false
    // },
    async changeUseVouchers () {
      if (!this.useVouchers) {
        await this.$store.dispatch('order/disableUseVouchers')
        await this.$store.dispatch('cart/removeCartVoucher', this.selected)
        this.useVouchers = false
      }
      if (this.useVouchers) {
        await this.$store.dispatch('order/enableUseVouchers')
        await this.$store.dispatch('cart/addCartVoucher', this.selected)
      } else {
        await this.$store.dispatch('order/disableUseVouchers')
        await this.$store.dispatch('cart/removeCartVoucher', this.selected)
      }
      if (this.posType === 0) {
        await this.$store.dispatch('order/checkOrder')
      } else {
        await this.$store.dispatch('order/calculateOrder')
      }
    },
    async changeVoucher () {
      await this.$store.dispatch('cart/addCartVoucher', this.selected)
      if (this.posType === 0) {
        await this.$store.dispatch('order/checkOrder')
      } else {
        await this.$store.dispatch('order/calculateOrder')
      }
    }
  },
  watch: {
    async selected(newVal, oldVal) {
      await this.$store.dispatch('cart/removeCartVoucher', oldVal)
    },
    async discountInfo(newVal, oldVal) {
      if (!newVal.bill_member_voucher_id) {
        this.useVouchers = false
      }
    }
  },
  async created () {
    // prevent duplicate voucher
    this.filteredDiscounts = this.discounts.filter((v, index) => {
      const v_id = v.voucher_id;
      return index === this.discounts.findIndex(obj => {
        return obj.voucher_id === v_id;
      });
    });

    if (this.filteredDiscounts && this.filteredDiscounts.length > 0) {
      if (this.vouchers.length > 0){
        for (let i = 0; i < this.vouchers.length; i++) {
          if (this.checkConditions(this.vouchers[i])) {
            this.selected = this.vouchers[i].voucher_id
          }
          let cartVoucher = this.discounts.find(v => v.id === this.vouchers[i].member_voucher_id)
          if (cartVoucher && cartVoucher && this.checkConditions(cartVoucher)) {
            this.selected = cartVoucher.voucher_id
          }
          if (this.selected) await this.changeVoucher()
        }
      } else {
        for (let i = 0; i < this.filteredDiscounts.length; i++) {
          if (this.checkConditions(this.filteredDiscounts[i])) {
            this.selected = this.filteredDiscounts[i].voucher_id
            await this.changeVoucher()
            break
          }
        }
      }
      if (this.posType === 0) {
        await this.$store.dispatch('order/checkOrder')
      } else {
        await this.$store.dispatch('order/calculateOrder')
      }
      this.useVouchers = true
    }
  }
}
</script>

<style scoped>
.note {
  font-weight: 400;
  font-size: smaller;
}
.option {
  margin-top: -35px;
  margin-left: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/UseVouchers.vue